document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-toggle").forEach((button) => {
    button.addEventListener("click", function () {
      let content = this.closest(".accordion-container").querySelector(".accordion-content");
      
      // Get the icon elements
      let plusIcon = this.querySelector("[data-icon='plus']");
      let minusIcon = this.querySelector("[data-icon='minus']");

      // Toggle the display of the content
      if (content.style.display === "block") {
        content.style.display = "none";
        this.setAttribute("aria-expanded", "false"); // Collapse state
        content.setAttribute("aria-hidden", "true");

        // Toggle icon classes: plus is active when closed
        plusIcon.classList.add("icon--active");
        minusIcon.classList.remove("icon--active");
      } else {
        content.style.display = "block";
        this.setAttribute("aria-expanded", "true"); // Expand state
        content.setAttribute("aria-hidden", "false");

        // Toggle icon classes: minus is active when open
        plusIcon.classList.remove("icon--active");
        minusIcon.classList.add("icon--active");
      }
    });
  });
});
